import styled from 'styled-components'
import { cardHoverAnimation, myPalette } from '~/shared/ui/theme'

export const Card = styled.div`
  box-shadow: 0 0 5px ${myPalette.dark.shadowLight};
  background-color: ${myPalette.white.main};
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  padding: 16px;
  ${cardHoverAnimation}
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const Img = styled.img`
  width: 36px;
  height: 36px;
`

export const Title = styled.span`
  font-size: 14px;
  line-height: 18px;
  color: ${myPalette.dark.main};
`

export const Amount = styled.div`
  font-size: 18px;
  color: ${myPalette.midnightBlue.main};
  white-space: nowrap;
`
